import { Typography, ListItemButton } from "@mui/material"
import { ReactElement } from "react"
import { useMatch } from "react-router-dom"

import { useClickNavButton } from "./useClickNavButton"
import { BUTTON_RADIUS_MULTIPLIER } from "../../../../themes/defaultThemeParams"

type NavButtonProps = {
    title: string
    icon: ReactElement
    route: string
    external?: boolean
}

/**
 * Navigation buttons used on the application navigation bar when it is
 * displayed in "horizontal" mode (i.e. as a navigation bar as a bar at the
 * top of the webpage horizontally
 *
 * @example
 * < NavButtonHorizontal title="test" icon={Icon} route="/"/>
 */
const NavButtonHorizontal = ({
    title,
    icon,
    route,
    external,
}: NavButtonProps): ReactElement => {
    const { clickNavButton } = useClickNavButton(route, external)
    const selected = !!useMatch(route)
    return (
        <ListItemButton
            sx={{
                textTransform: "none",
                borderRadius: BUTTON_RADIUS_MULTIPLIER,
                paddingX: 2,
                flexGrow: 0,
            }}
            color="primary"
            selected={selected}
            onClick={clickNavButton}
        >
            {icon}
            <Typography
                variant="body1"
                color={selected ? "primary" : "text.primary"}
                fontWeight={selected ? "bold" : "normal"}
            >
                {title}{" "}
            </Typography>
        </ListItemButton>
    )
}

NavButtonHorizontal.defaultProps = {
    external: false,
}

export default NavButtonHorizontal
